import { render, staticRenderFns } from "./EditTindakan.vue?vue&type=template&id=2115a00c&lang=pug&"
import script from "./EditTindakan.vue?vue&type=script&lang=js&"
export * from "./EditTindakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports